/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./audioSetting.vue?vue&type=template&id=8c2f13d0&scoped=true&"
import script from "./audioSetting.vue?vue&type=script&lang=js&"
export * from "./audioSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2f13d0",
  null
  
)

export default component.exports